import { queryRecommendList } from "@/api/product";
import { ProductDetailModel, ProductModel } from "@akc/biz-api";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const useRecommendProductList = ({
  product,
  scene,
  orderNo,
  orderDetailNo,
  activitySpuIds,
}: {
  product?: ProductDetailModel;
  scene?: string;
  orderNo?: string;
  orderDetailNo?: string;
  activitySpuIds?: string[];
}) => {
  // 当前页（必须在1~500之间！）
  const pageNum = useRef<number>(1);
  // 是否有下一页
  const [hasNext, setHasNext] = useState(false);
  // 商品列表
  const [recommendProductList, setRecommendProductList] = useState<ProductModel[]>([]);
  const [search] = useSearchParams();

  const fetchProductList = async () => {
    if (!scene) {
      return;
    }
    const res = await queryRecommendList({
      pageId: "H5_Search",
      activitySpuIds,
      pageIndex: pageNum.current,
      pageSize: 10,
      scene: scene,
      categoryCode: product?.spuCategoryInfoVO?.categoryCode,
      voConfig: {
        showType: 2,
      },
      orderNo,
      detailNo: orderDetailNo,
    });
    const result = res?.result ?? [];
    setRecommendProductList(productList => {
      return [
        ...productList,
        ...(result?.map((item, index) => ({
          ...item,
          rank: productList.length + index,
          trackData: {
            recommend_requestid: `${res?.extra?.searchRequestId ?? Date.now()}`,
            domain: product ? "商品详情" : "已删除商品推荐",
            module: product ? "好货推荐" : "已删除商品推荐",
            resource_type: product ? "大家都在买" : "已删除商品推荐",
            resource_content: "商品",
            resource_name: product ? "大家都在买" : "已删除商品推荐",
            click_activity_id: item.activityId,
            click_activity_spu_code: item.activitySpuId,
            click_sku_id: item.selectSkuId,
            btn_name: "推荐商品", //这个字段在taro组件内部有对点击、分享、加购等场景分别覆盖处理
            resource_id: item.activitySpuId,
            resource_rank: productList.length + index + 1,
            product_model: item.activityType === 4 ? "普通商品" : "档期商品",
            price: item?.skuCurrentPriceInfo?.marketingPrice,
            activity_spu_code: product?.activitySpuId,
            sku_id: product?.selectSkuId,
            activity_id: product?.activityId,
            previous_page_name: search.get("page_name") ?? search.get("previous_page_name"),
            tracking_plan_ids: {
              expose: "14442", // 卡片曝光
              click: "14443", // 卡片主点击事件
            },
          },
        })) ?? []),
      ];
    });
    setHasNext(res?.hasNext ?? false);
    pageNum.current = (res?.pageIndex ?? 1) + 1;
  };

  // 加载更多
  const onLoadNextPage = async () => {
    await fetchProductList();
  };

  useEffect(() => {
    setRecommendProductList([]);
    pageNum.current = 1;
    fetchProductList();
  }, [scene]);

  return {
    hasNext,
    recommendProductList,
    onLoadNextPage,
  };
};

export default useRecommendProductList;
